import React, { Component } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { DateTimePicker } from '@progress/kendo-react-dateinputs'
import { connect } from 'react-redux';
import { getColors, getSizes, getProductTypes } from '../../../../../Redux/Actions/CommonActions';
import './../ManageEvents/Events.scss';
import ReactFileReader from 'react-file-reader';
import { Switch } from '@progress/kendo-react-inputs';
import '@progress/kendo-react-common'
import '@progress/kendo-date-math'
import axios from 'axios'
import { ROOT_API_URL } from '../../../../../api-config';
import { auth } from '../../../../../services/auth.service';

class MemberDiscountsForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			memberDiscountInEdit: this.props.dataItem || null,
			originalCompanyName: this.props.dataItem ? this.props.dataItem.CompanyName : '',
			description: this.props.dataItem ? this.props.dataItem.Description : '',
			companyName: this.props.dataItem ? this.props.dataItem.CompanyName : '',
			imageUrl: this.props.dataItem ? this.props.dataItem.LogoImage : '',
			isImageChanged: false,
			externalURL: this.props.dataItem ? this.props.dataItem.ExternalURL : '',
			companyNameMessage: ''
		};
	};

	handleSubmit = (event) => {
		event.preventDefault();

		let model = {
			description: this.state.description,
			companyName: this.state.companyName,
			membershipDiscountId: this.state.memberDiscountInEdit ? this.state.memberDiscountInEdit.MembershipDiscountId : 0,
			logoImage: this.state.imageUrl,
			image: this.state.image,
			externalURL: this.state.externalURL,
			isImageChanged: this.state.isImageChanged
		}

		axios.post(`${ROOT_API_URL}/ManageMemberDiscounts/IsDuplicateCompanyName`, model, { headers: auth.authHeader() })
			.then((response) => {
				if (response.data.message != "" && this.state.originalCompanyName != this.state.companyName) {
					this.setState({
						companyNameMessage: response.data.message
					})
				}
				else {
					this.props.save(model);
				}
			})
			.catch((response) => {
				console.log(response);
			});
	}

	handleImageFiles = (event) => {

		this.setState({
			imageUrl: event.base64,
			isImageChanged: true,
			image: {
				name: event.fileList[0].name,
				source: event.base64,
				extension: event.fileList[0].type
			}
		});
	}

	handlePdfFiles = (event) => {
		let Pdf = event ? {
			name: event.fileList[0].name,
			source: event.base64,
			extension: event.fileList[0].type
		} : null;

		this.setState({
			pdf: Pdf,
			uploadTitle: event.fileList[0].name,
			isPdfChanged: true
		});
	}

	onCompanyNameChange = (event) => {
		this.setState({
			companyName: event.target.value
		})
	}

	onDescriptionChange = (event) => {
		this.setState({
			description: event.target.value
		})
	}

	onExternalURLChange = (event) => {
		this.setState({
			externalURL: event.target.value
		})
	}

	render() {
		return (
			<div className="memberDiscount-form">
				<Dialog onClose={this.props.cancel}>
					{this.state.memberDiscountInEdit.MembershipDiscountId ?
						<h2 className="adjust-dist-title2">Edit Member Discount</h2>:
						<h2 className="adjust-dist-title2">Add New Member Discount</h2> }
					<form className="" onSubmit={this.handleSubmit}>												
						<div className="row">
							<div className="form-group col-md-6">
								<label htmlFor="CompanyName">Company Name</label>
								<Input
									required={true}
									type="text"
									name="CompanyName"
									id="CompanyName"
									value={this.state.companyName}
									onChange={this.onCompanyNameChange}
								/>
								<p className="error-message" style={{ color: "#d0021b" }}>{this.state.companyNameMessage}</p>
							</div>
							<div className="form-group col-md-6">
								<label htmlFor="ExternalURL">External URL</label>
								<Input
									type="url"
									required={true}
									type="text"
									name="ExternalURL"
									id="ExternalURL"
									value={this.state.externalURL}
									onChange={this.onExternalURLChange}
								/>
							</div>							
						</div>
						<div className="row">
							<div className="form-group col-md-12">
								<label htmlFor="Description">Description</label>
								<textarea
									required={true}
									type="text"
									name="Description"
									id="Description"
									className="k-textarea"
									value={this.state.description}
									onChange={this.onDescriptionChange}
								/>
							</div>
						</div>
						<div className="row">
							<div className="col-md-6">
								<label htmlFor="">Cover Image</label>
								<ReactFileReader required={true} fileTypes={[".jpg", ".jpeg", ".png"]} base64={true} multipleFiles={false} handleFiles={this.handleImageFiles} >
									<div className='btnPrimary'>
										<i className="fas fa-file-upload"></i>
										<span>Upload File</span>
									</div>
								</ReactFileReader>
								
							<div>						
									{this.state.imageUrl ?
										<div>
											<br></br>
											<img alt="" src={this.state.imageUrl} />
										</div>										
									:""}
								</div>
							</div>							
							<div className="col-md-6">
							</div>
						</div>
						<DialogActionsBar>
							<div className="adjust-btns">
								<div className="form-group">
									<button className="admin-k-button" onClick={this.props.cancel}>
										<i className="fas fa-times"></i>
										<span> CANCEL</span>
									</button>
									{this.state.memberDiscountInEdit.MembershipDiscountId ? (
										<button type="submit" className="admin-k-button">
											<i className="fas fa-edit"></i>
											<span> UPDATE</span>
										</button>
									) : (
											
										<button type="submit" className="admin-k-button">
											<i className="fas fa-save"></i>
											<span> SAVE</span>
										</button>
										)}
								</div>
							</div>
						</DialogActionsBar>
					</form>
				</Dialog>
			</div>
		);
	}
}

export default MemberDiscountsForm;
